module.exports = __webpack_public_path__ + "static/media/verticalIcon.23d0106b.svg";